import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Box, BoxProps } from 'ui/Layout';

import { customIcons, fontAwesomeIcons } from './constants';

export type IconType = keyof typeof fontAwesomeIcons | keyof typeof customIcons;

const isCustomIcon = (icon: IconType): icon is keyof typeof customIcons =>
  Object.keys(customIcons).includes(icon);

type Props = BoxProps & { icon: IconType };

// TODO: Consider wrapping this with Chakra <Icon> component: https://www.chakra-ui.com/docs/components/icon
const Icon: React.FC<Props> = ({ icon, ...props }) => (
  <Box as="span" lineHeight={0} {...props}>
    {isCustomIcon(icon) ? (
      customIcons[icon]
    ) : (
      <FontAwesomeIcon icon={fontAwesomeIcons[icon]} />
    )}
  </Box>
);

export default Icon;
